import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { loadingAction, resetContext } from 'store/globalState/global';
import { goHome, getNarrative, resetAll } from 'modules/steps/actions';
import { setBreadcrumb } from 'components/Navbar/modules';
import { setAutoNavigation } from 'routes/MainPage/modules/mainPage';
import ProfileComponents from '../components';
import { uploadImage } from '../../Signup/modules/signup';
import { updateProfile, deleteAccount } from '../modules/actions';


function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.profile,
    newAvatar: state.signup.avatar || '',
    userLang: state.i18n.language,
    app: state.app,
    eraseAccountStatus: state.profile.eraseAccountStatus,
    eraseAccountError: state.profile.eraseAccountError,
    userElements: state.elements.selectedElements,
    userThemeTables: state.thinkChats.myThinkChatsList.concat(state.thinkTanks.myThinkTanksList),
    userCallsForImpact: state.narratives.myCallsForImpact,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showLoading: bindActionCreators(loadingAction, dispatch),
    uploadImage: bindActionCreators(uploadImage, dispatch),
    updateProfile: bindActionCreators(updateProfile, dispatch),
    setBreadcrumb: bindActionCreators(setBreadcrumb, dispatch),
    resetContext: bindActionCreators(resetContext, dispatch),
    goHome: bindActionCreators(goHome, dispatch),
    getNarrative: bindActionCreators(getNarrative, dispatch),
    setAutoNavigation: bindActionCreators(setAutoNavigation, dispatch),
    resetAll: bindActionCreators(resetAll, dispatch),
    deleteAccount: bindActionCreators(deleteAccount, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProfileComponents));



// WEBPACK FOOTER //
// ./src/routes/Profile/container/index.js